import { useAuth } from 'hooks'
import { useRouter } from 'next/router'
import Link from 'next/link'
import { CountDownTimer, Button } from '@components'
import HeroImage from './inflation-hero.webp'
import { useState } from 'react'

export const InflationHedgeHero = ({
  closingAt,
  id,
}: {
  closingAt: any
  id?: number
}) => {
  const { currentUser } = useAuth()
  const router = useRouter()
  const [isSubmitting, setIsSubmitting] = useState(false)

  const submitInvestmentAmount = () => {
    setIsSubmitting(true)

    router.push(`/invest/company/inflationhedge/deals/${id}/subscribe`)
    setIsSubmitting(false)
  }

  return (
    <div
      className="h-[543px] bg-cover bg-center bg-no-repeat lg:h-[930px]"
      style={{
        backgroundImage: `url(${HeroImage?.src})`,
      }}>
      <div className="mx-auto flex w-full flex-col items-center pt-24 lg:w-[49%] lg:pt-[9.5rem]">
        <h1 className="text-center font-heading text-xl font-extrabold text-white lg:text-5xl">
          A new inflation hedge has arrived.
        </h1>
        <p className="px-24 pb-12 pt-5 text-center text-white md:px-48 lg:px-12">
          <span className="text-[#A7A9AC]">
            {' '}
            Diversify your portfolio and beat inflation with a new hybrid
            investment product of
          </span>{' '}
          US Treasury Bills and Pre-IPO Shares.
        </p>
        {currentUser ? (
          <div className="mx-auto flex w-full flex-col items-center justify-center lg:w-3/5 lg:flex-row">
            <div className="lg:mr-6">
              <Button
                onClick={() => submitInvestmentAmount()}
                disabled={isSubmitting}
                loading={isSubmitting}>
                Invest now
              </Button>
            </div>

            <Link href="#potential-return" className="mt-6 lg:mt-0">
              <Button light>Estimate your returns</Button>
            </Link>
          </div>
        ) : (
          <Link href="/signup">
            <Button>Request access</Button>
          </Link>
        )}
      </div>
      {currentUser && closingAt && (
        <div className="absolute right-14 top-[130px] hidden pt-10 text-white lg:block lg:w-fit">
          <div className="flex flex-col items-center">
            <div className="w-full rounded-full border border-[#6D45B5] px-4">
              <CountDownTimer
                closingAt={new Date(closingAt)}
                timeOnly
                backgroundTransparent
              />
            </div>
            <p className="pt-3 text-sm">Remaining time to invest</p>
          </div>
        </div>
      )}
    </div>
  )
}
